// extracted by mini-css-extract-plugin
module.exports = {"link":"PostLink-module--link--3RF2N","postInfo":"PostLink-module--postInfo--3tKkr","postTitle":"PostLink-module--postTitle--Q0vJB","postDate":"PostLink-module--postDate--13MMQ"};